import React, { useState } from 'react';
import {
  Box, Button, FormControlLabel, Radio, RadioGroup, FormControl,
} from '@mui/material';
import ColorPicker from './ColorPicker';

type FontFamilies = {
  [key: string]: string;
};

interface ChangeLayoutSettingProps {
  main_color: string;
  text_color: string;
  background_color: string;
  text_font: string;
  onMainColorChange: (color: string) => void;
  onTextColorChange: (color: string) => void;
  onBackgroundColorChange: (color: string) => void;
  onFontChange: (font: string) => void;
}

export default function ChangeLayoutSetting({
  onMainColorChange,
  onTextColorChange,
  onBackgroundColorChange,
  onFontChange,
  main_color,
  text_color,
  background_color,
  text_font,
}: ChangeLayoutSettingProps) {
  const [mainColorHex, setMainColorHex] = useState(main_color ?? '#2664b1');
  const [textColorHex, setTextColorHex] = useState(text_color ?? '#333333');
  const [backgroundColorHex, setBackgroundColorHex] = useState(background_color ?? '#ffffff');
  const [selectedFont, setSelectedFont] = useState(text_font || '');

  const fontFamilies: FontFamilies = {
    default: '',
    'sans-serif': 'sans-serif',
    monospace: 'monospace',
    serif: 'serif',
  };

  const containerStyles = {
    backgroundColor: backgroundColorHex,
    color: textColorHex,
    fontFamily: selectedFont,
  };

  const handleMainColorChange = (color: string) => {
    setMainColorHex(color);
    onMainColorChange(color);
  };

  const handleTextColorChange = (color: string) => {
    setTextColorHex(color);
    onTextColorChange(color);
  };

  const handleBackgroundColorChange = (color: string) => {
    setBackgroundColorHex(color);
    onBackgroundColorChange(color);
  };

  const handleFontChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedKey = (event.target as HTMLInputElement).value;
    const fontFamilyValue = fontFamilies[selectedKey];
    setSelectedFont(fontFamilyValue);
    onFontChange(fontFamilyValue);
    console.log('fontFamilyValue', fontFamilyValue);
  };

  return (
    <Box>
      <h2 className="mb-3">Colors & Fonts</h2>
      <p className="mb-1">Define the page styles.</p>
      <hr className="mt-3" />
      <div className=" my-3">
        <label className="col-form-label text-bold mb-1">
          Color
        </label>
        <div className="d-flex flex-column">
          <ColorPicker label="Brand Color" colorHex={mainColorHex} onColorChange={handleMainColorChange} />
          <ColorPicker label="Text" colorHex={textColorHex} onColorChange={handleTextColorChange} />
          <ColorPicker
            label="Background"
            colorHex={backgroundColorHex}
            onColorChange={handleBackgroundColorChange}
          />
        </div>
        <hr className="mt-3" />
        <div className="d-flex flex-column">
          <label className="col-form-label text-bold mb-1">Font</label>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="font"
              defaultValue={selectedFont}
              onChange={handleFontChange}
            >
              <FormControlLabel
                value="helvetica"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="Base"
              />
              <FormControlLabel
                value="sans-serif"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="Gothic (Sans-Serif)"
              />
              <FormControlLabel
                value="monospace"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="Gothic Mono (Monospace)"
              />
              <FormControlLabel
                value="serif"
                control={<Radio sx={{ paddingY: 0, marginBottom: '8px' }} />}
                label="Mincho (Serif)"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <hr className="mt-3" />
        <div className="row">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center">
              <div className="card w-100" style={containerStyles}>
                <div className="card-body py-3 text-center">
                  <h1 className="">Style Preview</h1>
                </div>
                <div className="card-body py-0">
                  <p>
                    The text style is displayed here. The text style is displayed here. The text style is displayed here. The text style is displayed here.
                  </p>
                </div>
                <div className="card-body py-3 text-center">
                  <Button
                    className="btn btn-primary"
                    variant="contained"
                    component="label"
                    size="small"
                    style={{
                      width: '80px',
                      backgroundColor: mainColorHex,
                      border: `2px solid ${mainColorHex}`,
                    }}
                  >
                    Button
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
